<template>
  <div class="wrapper">
    <div class="animated fadeIn">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i class="fa fa-legal"></i> <strong>Suspect Matches</strong>
              <span class="badge badge-primary">{{this.$route.params.username}}</span>
              <div class="card-actions">
                <div class="btn-group" role="group" aria-label="Basic example">
                  <template v-for="(item, index) in servers" v-if="!item.readonly">
                    <button type="button" @click="switchServer(index)"
                            :class="['btn-' + item.colour, activeServer === index ? 'active' : '']"
                            class="btn btn-small">{{capitalizeFirstLetter(index)}}
                    </button>
                  </template>
                </div>
              </div>
            </div>

            <div>
              <ag-grid-vue style='width: 100%; height: 700px' class='ag-theme-alpine-dark tradelog'
                           :gridOptions='gridOptions'
                           :enableColResize="true"
                           :enableFilter="true"
                           :masterDetail="true"
                           :detailCellRenderer="detailCellRenderer"
                           :rowData="pvplogs.data"
                           :groupHeaders="true"
                           @first-data-rendered="onFirstDataRendered">
              </ag-grid-vue>
            </div>
          </b-card>
    </div>
  </div>
</template>
<script>
import {AgGridVue} from 'ag-grid-vue'
import 'ag-grid-enterprise'
import PvPDetailCellRenderer from '@/views/user/pvplog/PvPDetailCellRenderer.js'
import Servers from '../../_servers'
import moment from 'moment'
import {mapGetters} from 'vuex'
import ServerMenu from '@/components/Servernenu.vue'
import {DefaultGridOptions} from "@/default_table_settings";
import {applyGridPersistence} from "@/grid_persistence"
import iziToast from 'izitoast'

  const None	= 0
  const  PvP	= 1
  const  Wild	 = 1 << 1
  const  Trainer  = 1 << 2
  const  Ranked   = 1 << 3
  const  Random	 = 1 << 4
  const  Friendly = 1 << 5
  export default {
    props: ['records'],
    data () {
      return {
        gridOptions: null,
        showToolPanel: false,
        disableRecover: false,
        disableDelete: false,
        activeServer: Object.keys(Servers)[0],
        disableTransfer: false,
        modalTitle: '',
        detailCellRenderer: 'PvPDetailCellRenderer',
        neutralRatingChanges: true,
        linkDetailPlayers: true,
        cb: null,
        loading: false,
        lock: false,
        servers: Servers,
      }
    },
    computed: {
      ...mapGetters({
        pvplogs: 'PVPlogs'
      }),
      username() {
        return this.$route.params.username || 'suspect'
      }
    },
    components: {
      ServerMenu,
      PvPDetailCellRenderer,
      'ag-grid-vue': AgGridVue
    },
    methods: {
      onFirstDataRendered(params) {
        params.api.forEachNode(function (node) {
        });
      },
      switchServer (index) {
        this.activeServer = index
        this.$router.push({ path: 'suspect_matches', query: { server: index } })
        this.loading = true
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      formatMinutes (minutes) {
        let h = Math.floor(minutes / 60)
        let m = minutes % 60
        if (h <= 0) {
          return m + 'm'
        } else {
          return h + 'h'
        }
      },
      formatPrice (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
      checkPermission (perm) {
        return perm.and(this.authUser.permission).neq(0)
      },
      formatDateDisplay(date) {
        if (!date || String(date).startsWith('0001')) return '-'
        return moment(date).format('YYYY-MM-DD HH:mm')
      },
      formatBattleTypes(data) {
        if (!data) return ''
        let types = []
        if (data.type & PvP) types.push('PvP')
        if (data.type & Wild) types.push('Wild')
        if (data.type & Trainer) types.push('Trainer')
        if (data.type & Ranked) types.push('Ranked')
        if (data.type & Random) types.push('Random')
        if (data.type & Friendly) types.push('Friendly')
        return types.join('/')
      },
      teamNames(player) {
        if (!player || !player.pokemon) return ''
        return Object.values(player.pokemon).map(poke => poke.name).join(', ')
      },
      renderTeamBadges(player) {
        if (!player || !player.pokemon) return ''
        return `<div class="d-flex align-items-center suspect-team-list">` +
          Object.values(player.pokemon).slice(0, 6).map(poke => {
            return `<span class="badge badge-dark border border-secondary suspect-team-badge" title="Lvl ${poke.level || '-'}">${poke.name || '-'}</span>`
          }).join('') + `</div>`
      },
      renderRatingChange(value) {
        const val = Number(value || 0)
        return `<span class="font-weight-bold suspect-small">${val > 0 ? '+' : ''}${val}</span>`
      },
      renderUserLink(username) {
        if (!username) return '<span>-</span>'
        const target = this.$router.resolve({
          name: 'User',
          params: { username },
          query: { server: this.activeServer }
        }).href
        return `<a href="${target}" class="font-weight-bold text-primary">${username}</a>`
      },
      hasSameValue(left, right) {
        return !!left && !!right && String(left) === String(right)
      },
      renderNetworkValue(type, value, isMatch) {
        const text = value || '-'
        const classes = isMatch ? 'text-danger font-weight-bold' : 'text-success'
        const title = isMatch ? `${type} matches opponent` : type
        return `<small class="clickable-net ${classes}" data-type="${type}" data-val="${value || ''}" title="${title}">${text}</small>`
      },
      renderNetworkCell(data) {
        const u = data && data.user ? data.user : {}
        const o = data && data.opponent ? data.opponent : {}
        const sameIP = this.hasSameValue(u.IP, o.IP)
        const sameMAC = this.hasSameValue(u.MAC, o.MAC)
        return `<div class="d-flex w-100 justify-content-between align-items-center suspect-network-cell">
          <div class="mr-2 border-right border-secondary pr-2 suspect-network-side">
            ${this.renderNetworkValue('IP', u.IP, sameIP)}
            ${this.renderNetworkValue('MAC', u.MAC, sameMAC)}
          </div>
          <div class="suspect-network-side">
            ${this.renderNetworkValue('IP', o.IP, sameIP)}
            ${this.renderNetworkValue('MAC', o.MAC, sameMAC)}
          </div>
        </div>`
      },
      showShared(type, value) {
        this.$store.commit('setSharedIPs', null)
        let event = ''
        let payload = { server: this.pvplogs.server }
        let title = ''

        if (type === 'IP') {
          event = 'getSharedIPs'
          payload.ip = value
          title = 'Shared IP: ' + value
        } else if (type === 'MAC') {
          event = 'getSharedMACs'
          payload.mac = value
          title = 'Shared MAC: ' + value
        }

        if (event) {
          this.emit(event, payload)
          this.$root.$emit('show-shared-modal', {
            title,
            server: this.pvplogs.server
          })
        }
      },
      onCellClicked(params) {
        if (params.event.target.classList.contains('clickable-net')) {
          const type = params.event.target.getAttribute('data-type')
          const val = params.event.target.getAttribute('data-val')
          if (type && val) {
            this.showShared(type, val)
          }
        }
      },
      getReplayUsername(match) {
        return match && match.user && match.user.name ? match.user.name : this.username
      },
      createColumnDefs () {
        return [
          {
            headerName: '',
            width: 30,
            pinned: 'left',
            cellRenderer: 'agGroupCellRenderer',
            cellRendererParams: {
              suppressCount: true,
              innerRenderer: () => ''
            },
            resizable: true,
            sortable: false,
            filter: false,
            suppressMenu: true
          },
          {
            headerName: 'Result',
            width: 85,
            pinned: 'left',
            filter: 'agSetColumnFilter',
            valueGetter: params => {
              if (params.data && params.data.isDraw) return 'DRAW'
              return params.data && params.data.won ? 'WIN' : 'LOSS'
            },
            cellRenderer: params => {
              const text = params.value || 'LOSS'
              const color = text === 'WIN' ? 'success' : (text === 'DRAW' ? 'secondary' : 'danger')
              return `<span class="badge badge-${color} shadow-sm suspect-result-badge">${text}</span>`
            }
          },
          {
            headerName: 'User',
            field: 'user.name',
            width: 130,
            pinned: 'left',
            filter: 'agTextColumnFilter',
            cellRenderer: params => this.renderUserLink(params.value)
          },
          {
            headerName: 'Opponent',
            field: 'opponent.name',
            width: 130,
            pinned: 'left',
            filter: 'agTextColumnFilter',
            cellRenderer: params => this.renderUserLink(params.value)
          },
          {
            headerName: 'Battle',
            headerClass: 'text-center border-left',
            children: [
              {
                headerName: 'Type',
                field: 'type',
                width: 100,
                filter: 'agSetColumnFilter',
                valueGetter: params => this.formatBattleTypes(params.data),
                cellRenderer: params => `<span class="text-info suspect-small">${params.value}</span>`
              },
              {
                headerName: 'Duration',
                width: 90,
                sortable: true,
                filter: 'agNumberColumnFilter',
                comparator: (a, b) => a - b,
                valueGetter: params => {
                  if (!params.data.startTime || !params.data.endTime) return 0
                  return moment(params.data.endTime).diff(moment(params.data.startTime))
                },
                cellRenderer: params => params.value ? moment.utc(params.value).format('mm:ss') : '-',
                cellStyle: { 'font-family': 'monospace', 'font-size': '0.75rem' }
              }
            ]
          },
          {
            headerName: 'Teams',
            headerClass: 'text-center border-left',
            children: [
              {
                headerName: 'User Team',
                width: 220,
                filter: 'agTextColumnFilter',
                valueGetter: params => this.teamNames(params.data.user),
                cellRenderer: params => this.renderTeamBadges(params.data.user)
              },
              {
                headerName: 'Opponent Team',
                width: 220,
                filter: 'agTextColumnFilter',
                valueGetter: params => this.teamNames(params.data.opponent),
                cellRenderer: params => this.renderTeamBadges(params.data.opponent)
              }
            ]
          },
          {
            headerName: 'Technical',
            headerClass: 'text-center border-left',
            children: [
              {
                headerName: 'User +/-',
                field: 'user.ratingChange',
                width: 75,
                sortable: true,
                filter: 'agNumberColumnFilter',
                cellRenderer: params => this.renderRatingChange(params.value)
              },
              {
                headerName: 'Opponent +/-',
                field: 'opponent.ratingChange',
                width: 95,
                sortable: true,
                filter: 'agNumberColumnFilter',
                cellRenderer: params => this.renderRatingChange(params.value)
              },
              {
                headerName: 'Network (User vs Opponent)',
                width: 260,
                filter: 'agTextColumnFilter',
                valueGetter: params => {
                  const u = params.data.user || {}
                  const o = params.data.opponent || {}
                  return `${u.IP || ''} ${u.MAC || ''} ${o.IP || ''} ${o.MAC || ''}`
                },
                cellRenderer: params => this.renderNetworkCell(params.data)
              }
            ]
          },
          {
            headerName: 'Date',
            field: 'startTime',
            width: 135,
            sortable: true,
            sort: 'desc',
            filter: 'agDateColumnFilter',
            cellRenderer: params => `<span class="text-muted suspect-small">${this.formatDateDisplay(params.value)}</span>`,
            tooltipValueGetter: params => {
              if (!params.value) return ''
              const m = moment(params.value)
              return `Local: ${m.local().format('YYYY-MM-DD HH:mm:ss')}`
            }
          },
          {
            headerName: 'Battle End',
            field: 'endTime',
            width: 135,
            filter: 'agDateColumnFilter',
            cellRenderer: params => `<span class="text-muted suspect-small">${this.formatDateDisplay(params.value)}</span>`,
            tooltipValueGetter: params => {
              if (!params.value) return ''
              const m = moment(params.value)
              return `Local: ${m.local().format('YYYY-MM-DD HH:mm:ss')}`
            }
          },
          {
            headerName: 'End Reason',
            field: 'endReason',
            width: 140,
            valueFormatter: data => data.value || 'unknown'
          }
        ]
      },
      cellRenderer: function (param) {
        if (param.value) {
          return param.value.replace(/\n/g, '</br>')
        }
      },
      getContextMenuItems: function getContextMenuItems (params) {
        let self = this
        const data = params.node && params.node.data ? params.node.data : (params.node && params.node.parent ? params.node.parent.data : null)
        let menu = [
          'copy',
          'copyWithHeaders',
          'separator',
          {
            name: 'Copy Replay Command',
            icon: '<i class="fa fa-clipboard"/>',
            disabled: !data || !data.ID,
            action: function () {
              const command = `/replay ${data.ID}, ${self.getReplayUsername(data)}`
              navigator.clipboard.writeText(command)
              iziToast.success({
                title: 'Copied',
                message: 'Replay command copied to clipboard',
                position: 'topRight'
              })
            }
          },
          'separator',
          {
            name: ' Check IP',
            icon: '<i class="fa fa-globe"/>',
            action: function () {
              let win = window.open('https://whatismyipaddress.com/ip/' + params.value, '_blank')
              win.focus()
            }
          },
          {
            name: ' Shared IP',
            icon: '<i class="fa fa-share-alt"/>',
            action: function () {
              self.emit('getSharedIPs', {'ip': params.value, 'server': self.pvplogs.server})
              self.$root.$emit('show-shared-modal', {
                title: 'Shared IP: ' + params.value,
                server: self.pvplogs.server
              });
            }
          },
          'separator',
          'export'
        ]
        return menu
      }
    },

    beforeMount () {
      this.gridOptions = Object.assign({}, DefaultGridOptions, {
        animateRows: true,
        headerHeight: 40,
        groupHeaderHeight: 30,
        floatingFiltersHeight: 40,
        rowClassRules: {
          "row-pass": params => params.data && params.data.won === true,
          "row-fail": params => params.data && params.data.won !== true
        },
        masterDetail: true,
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        context: { componentParent: this },
        onCellClicked: this.onCellClicked,
        getContextMenuItems: this.getContextMenuItems,
        getRowHeight: params => {
          if (params.node && params.node.detail) {
            const userPokes = params.data.user && params.data.user.pokemon ? Object.keys(params.data.user.pokemon).length : 0
            const oppPokes = params.data.opponent && params.data.opponent.pokemon ? Object.keys(params.data.opponent.pokemon).length : 0
            return (Math.max(userPokes, oppPokes) * 95) + 50
          }
          return 50
        }
    })
      applyGridPersistence(this.gridOptions, 'suspect-matches-grid')
      if(this.$route.query.server)
        this.activeServer = this.$route.query.server
      this.emit('suspect_matches', this.activeServer)

      this.gridOptions.columnDefs = this.createColumnDefs()
    },
    watch: {
      pvplogs: function (e) {
        this.loading = false

      }
    },
    beforeRouteUpdate (to, from, next) {
      if(to.query.server)
        this.activeServer = to.query.server
      this.emit('suspect_matches', this.activeServer)

      next()
    }
  }
</script>

<style scoped>
/deep/ .tradelog .ag-header-group-cell {
  font-weight: bold;
  font-size: 0.75rem;
  text-transform: uppercase;
  color: #8a9196;
  background-color: rgba(0, 0, 0, 0.1);
}

/deep/ .tradelog .ag-cell {
  display: flex;
  align-items: center;
  line-height: 1.2 !important;
}

/deep/ .tradelog .ag-row-hover {
  background-color: rgba(32, 168, 216, 0.05) !important;
}

/deep/ .tradelog .row-pass {
  background-color: rgba(77, 189, 116, 0.04);
}

/deep/ .tradelog .row-fail {
  background-color: rgba(248, 108, 107, 0.04);
}

/deep/ .suspect-result-badge {
  min-width: 45px;
  font-weight: 800;
  font-size: 0.7rem;
}

/deep/ .suspect-small {
  font-size: 0.75rem;
}

/deep/ .suspect-team-list {
  gap: 2px;
}

/deep/ .suspect-team-badge {
  font-size: 0.6rem;
  padding: 2px 4px;
  opacity: 0.8;
}

/deep/ .suspect-network-cell {
  height: 100%;
}

/deep/ .suspect-network-side {
  line-height: 1.1;
}

/deep/ .suspect-network-side small {
  display: block;
  font-size: 0.65rem;
}

/deep/ .clickable-net {
  cursor: pointer;
  transition: all 0.2s;
}

/deep/ .clickable-net:hover {
  color: #fff !important;
  text-decoration: underline;
  filter: brightness(1.2);
}
</style>
